import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";
import $ from "jquery";
import "datatables.net";

function Levels() {
  const navigate = useNavigate();
  const [levelsData, setLevelsData] = useState([]);
  const [deleteCategoryId, setDeleteCategoryId] = useState("");
  const [deleteTitle, setDeleteTitle] = useState("");
  const [dataTable, setDataTable] = useState(null);

  useEffect(() => {
    // Fetch the data from the API on component mount
    fetchData();
  }, []);

  useEffect(() => {
    // Initialize DataTable if levelsData is available
    if (levelsData.length) {
      if (dataTable) {
        dataTable.destroy();
      }
      const table = $("#level").DataTable({
        data: levelsData,
        columns: [
          { data: null, render: (data, type, row, meta) => meta.row + 1 }, // S.No

          { data: "level_name" }, 
        //   { data: "level_position" },
          { data: "hunt_count" }, 
          {
            data: "createdAt",
            render: (data) => new Date(data).toLocaleString(),
          }, // Date Added
          {
            data: null,
            render: (data) => {
              // <a href="/category_edit?id=${data._id}" class="crsr_pntr"><i class="fa-solid fa-pen mr-2"></i></a>
              return `
                                <div align="center">
                                     
                                     <a href="/level_edit?id=${data._id}" class="crsr_pntr"><i class="fa-solid fa-pen mr-2"></i></a>
                                </div>
                            `;
            }, // Action buttons (edit and delete)
          },
        ],
        pageLength: 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
      });
      setDataTable(table);

      // Event listener for the delete button
      $("#level").on("click", ".delete-btn", function () {
        const categoryId = $(this).data("id");
        const categoryName = $(this).data("name");
        // openDeleteModal(categoryId, categoryName);
      });
    }
  }, [levelsData]);

  const fetchData = async () => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY,
          secret: process.env.REACT_APP_SECRET,
          method: "getAllLevels",
          module: "user",
        }),
      });

      const data = response.data;
      if (data.statusCode === 200) {
        setLevelsData(data.result);
      } else {
        console.error("Failed to fetch contacts:", data);
        setLevelsData([]); // Clear data if fetching fails
      }
    } catch (error) {
      console.error("Error fetching geotag data:", error);
      setLevelsData([]); // Clear data if there's an error
    }
  };

 

  

  return (
    <div className="wrapper" id="root">
      <header>
        <NavigationBar />
      </header>

      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0 txt_lft">
                  Level
                  <a href="/level_add">
                    <i
                      className="fa-solid fa-square-plus ml-2"
                      title="Add Level"
                    />
                  </a>
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="table-responsive">
                  <table
                    id="level"
                    className="table table-striped table-bordered txt_lft"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Level</th>
                        {/* <th>Level Position</th> */}
                        <th>Hunt Count</th>
                        <th>CreatedAt</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      
    </div>
  );
}

export default Levels;
